import React from 'react'
import { Grid } from 'semantic-ui-react'
import _ from 'underscore'
import MickeyTable from '../MickeyTable/MickeyTable'
import PageHeader from '../PageHeader/PageHeader'
import DocumentTableRow from './DocumentTableRow'
import './DocumentTable.css'

const DocumentTable = (props) => {
  const {
    orderId,
    businessId,
    hideHeader,
    reload,
    setReload,
    canDelete,
    includeESignLogs,
    cargoUnitInstanceId,
  } = props
  const headerRow = props.hideOrderNumber
    ? ['Document Name', 'Document Type', 'Business', 'Date Created', 'Actions']
    : [
        'Document Name',
        'Order Number',
        'Business',
        'Document Type',
        'Date Created',
        'Actions',
      ]
  const headerSort = [
    {
      header: 'Document Name',
      sort_by: 'document_name',
    },
    {
      header: 'Order Number',
      sort_by: 'order__order_number',
      hidden: props.hideOrderNumber,
    },
    {
      header: 'Business',
      sort_by: 'business',
    },
    {
      header: 'Document Type',
      sort_by: 'document_type',
    },
    {
      header: 'Date Created',
      sort_by: 'created_at',
    },
  ]
  const headerSearch = [
    {
      header: 'Document Name',
      type: 'search',
      input_type: 'text',
      search_param: 'document_name',
    },
    {
      header: 'Order Number',
      type: 'search',
      input_type: 'text',
      search_param: 'order__order_number__icontains',
      hidden: props.hideOrderNumber,
    },
    {
      header: 'Business',
      type: 'search',
      input_type: 'text',
      search_param: 'business__icontains',
    },
    {
      header: 'Document Type',
      type: 'dropdown',
      options: [
        {
          text: 'Change Order',
          value: 'Change Order',
        },
        {
          text: 'Invoice',
          value: 'Invoice',
        },
        {
          text: 'Purchase Order',
          value: 'Purchase Order',
        },
        {
          text: 'Sales Order',
          value: 'Sales Order',
        },
        {
          text: 'Trucking Confirmation',
          value: 'Trucking Confirmation',
        },
        {
          text: 'Other',
          value: 'Other',
        },
        // {
        //   text: 'Commercial Invoice',
        //   value: 'Commercial Invoice',
        // },
        // {
        //   text: 'Supplier Invoice',
        //   value: 'Supplier Invoice',
        // },
        // {
        //   text: 'Bill of Lading',
        //   value: 'Bill of Lading',
        // },
        // {
        //   text: 'Packing List',
        //   value: 'Packing List',
        // },
        // {
        //   text: 'Sell Side Order Confirmation',
        //   value: 'Sell Side Order Confirmation',
        // },
        // {
        //   text: 'Buy Side Order Confirmation',
        //   value: 'Buy Side Order Confirmation',
        // },
        // {
        //   text: 'Trucking Release',
        //   value: 'Trucking Release',
        // },
        // {
        //   text: 'Proof of Delivery',
        //   value: 'Proof of Delivery',
        // },
      ],
      search_param: 'document_type',
    },
    {
      header: 'Date Created',
      type: 'date',
      type: 'date_range',
      search_param_start: 'created_at_start',
      search_param_end: 'created_at_end',
    },
  ]

  const urlParams = {}
  if (orderId) {
    urlParams.order_id = orderId
  }
  if (businessId) {
    urlParams.business_id = businessId
  }
  if (includeESignLogs) {
    urlParams.include_box_signing_logs = true
  }
  if (cargoUnitInstanceId) {
    urlParams.cargo_unit_instance_id = cargoUnitInstanceId
  }

  return (
    <>
      <Grid.Row className={'no-bottom-margin no-bottom-padding'}>
        {!hideHeader && (
          <Grid.Column
            width={8}
            className={'no-bottom-margin no-bottom-padding'}
          >
            <PageHeader
              header={'Documents'}
              showDivider
              className={
                'no-bottom-margin no-bottom-padding no-top-margin no-top-padding'
              }
              dividerClassName={'no-bottom-margin no-bottom-padding'}
            />
          </Grid.Column>
        )}
      </Grid.Row>
      <Grid.Row className={'no-top-margin no-top-padding'}>
        <Grid.Column width={8}>
          <MickeyTable
            headerRow={headerRow}
            headerSearch={headerSearch}
            headerSort={headerSort}
            urlParams={urlParams}
            basicSegment
            showHeaderNoData={true}
            reload={reload}
            setReload={setReload}
            url={'/main/documents/'}
            renderBodyRow={(data) => {
              return (
                <DocumentTableRow
                  document={data}
                  setReload={setReload}
                  canDelete={canDelete}
                  hideOrderNumber={props.hideOrderNumber}
                />
              )
            }}
            emptyIcon={'file'}
            emptyMessage={'No Documents'}
          />
        </Grid.Column>
      </Grid.Row>
    </>
  )
}

export default DocumentTable
